<template>
    <div>
        <div class="hrDetails-Msgbox">
            <div class="training-title">
                <div
                    class="training-top-bg"
                    :style="
                        'background-image:url(\'' + leariningMsg.assessCoverimg + '\')'
                    "
                >></div>
                <div class="training-top-opctiy"></div>
                <div class="training-back" @click="back">
                    <svg-icon icon-class="arrow-icon" class-name="arrow-icon"></svg-icon>
                </div>
                <ul class="trainingUl">
                    <li>
                        <a>
                            <img :src="leariningMsg.assessCoverimg" alt />
                        </a>
                        <div class="right">
                            <div class="right-info">
                                <h4
                                    class="training-list-title1 training-list-title"
                                >{{ leariningMsg.assessName }}
                                    <span v-if="leariningMsg.isValid" class="overdue">已过期</span>
                                </h4>
                                <p>有效期至：{{
                                    leariningMsg.validEndTime | formateData
                                    }}</p>
                                    <!-- 千万别删！！！ -->
                                <!-- <div class="overdue-tag">
                                    <span v-if="leariningMsg.isValid" class="overdue">已过期</span>
                                    <span v-if="leariningMsg.modelType" class="overdueType">{{leariningMsg.modelType===1?'素质':'专业'}}</span>
                                </div> -->
                            </div>
                        </div>
                    </li>
                    <div class="clear"></div>
                </ul>
            </div>

            <div class="training-content">
                <div class="courseDetail-content">
                    <div class="content-header">
                        <ul>
                            <li
                                class="headerspan"
                                @click="changecourseType(item)"
                                :class="
                                    changetype === item.id ? 'spanactive1' : ''
                                "
                                v-for="(item, index) in contentType"
                                :key="index"
                            >
                                <span>{{ item.name }}</span>
                            </li>
                        </ul>
                    </div>
                    <div v-if="changetype === '0'" class="content-info">
                        <p class="training_tips">{{ leariningMsg.assessIntroduce }}</p>
                    </div>
                    <div v-if="changetype === '1'" class="content-info1">
                        <div class="topicNum">
                            <p class="topictext"><span class="text1">总题数</span> <span class="text2">{{leariningMsg.questionNum}}</span></p>
                            <p class="totalimg">
                                <img src="../../../assets/images/humanResting/totalnum@2x.png" alt="">
                            </p>
                        </div>
                        <h2 class="historyTitle">历史测评记录</h2>
                        <div class="hrRecordList">
                            <ul v-if="!nohistory" class="hrlistUl">
                                <li v-for="(item, index) in historylist" :key="index" class="hrlistItem">
                                    <div class="hritemTime">
                                        <p class="hruseTime">用时：<span>{{item.duration}}秒</span></p>
                                        <p>{{item.endTime}}</p>
                                    </div>
                                    <p @click="goreport(item)" class="hritemBtn">查看报告</p>
                                </li>
                            </ul>
                            <div v-else class="nohistory">
                                <img src="../../../assets/images/humanResting/nohistory@2x.png" alt="">
                                <p class='nohistory-text'>暂无测评记录</p>
                            </div>
                        </div>   
                    </div>
                    <div class="hrstartbtn">
                        <button :class="isallow ? 'lightbtn' : 'disbtn'" @click="goTesting()">{{cepingbtntext}}</button>
                        <p v-if="!leariningMsg.frequency">不限次数</p>
                        <p v-else>（ 可测试{{leariningMsg.frequencyTimes}}次/剩余{{leariningMsg.remainderTimes}}次）</p>
                        <!-- 千万别删！！！ -->
                        <!-- <p v-else>（总次数：{{leariningMsg.assessTotal}}次，每次间隔：{{leariningMsg.intervalDay}}天）</p> -->
                    </div>   
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "hrDetails",
    data: () => {
        return {
            cepingbtntext: '',
            nohistory: false,
            changetype: "1",
            contentType: [
                { name: "简介", id: "0" },
                { name: "历史", id: "1" }
            ],
            activeName: "",
            leariningMsg: "",
            detailparams: "",
            isallow: false,
            historylist: [],
        };
    },
    computed: {
    },
    filters: {
        formateData: function(val) {
            return val ? val.split(" ")[0] : "";
        }
    },
    created() {
        
    },
    mounted() {
        if (window.history && window.history.pushState) {
            // 往历史记录里面添加一条新的当前页面的url
            history.pushState(null, null, document.URL);
            // 给 popstate 绑定一个方法 监听页面刷新
            window.addEventListener("popstate", this.back, false); //false阻止默认事件
        }
        this.detailparams = this.$route.query;
        this.findByIdAndRef();
        this.reportHistoryList();
    },
    destroyed() {
        window.removeEventListener("popstate", this.back, false); //false阻止默认事件
    },
    methods: {
        goreport(val){
            this.$router.push({
                path: "/reportdetail",
                query: {
                    resultId: val.id,
                    id: this.detailparams.id,
                    refId: this.detailparams.refId,
                    isValid: this.detailparams.isValid,
                    refType: this.detailparams.refType,
                    backType: this.$route.query.backType || '',
                    goodsId: this.$route.query.goodsId || '',
                }
            })
        },
        // 获取历史记录
        reportHistoryList() {
            let data = {
                assessId: this.detailparams.id || 11,
                refId: this.detailparams.refId || 11,
                refType: this.detailparams.refType || 1,
            }
            let params = {
                pageNum: 1,
                pageSize: 100,
            }
            this.$api.testreport.reportHistoryList({data, params}).then( res=> {
                if(!res.code){
                    this.historylist = res.data.list;
                    this.nohistory = this.historylist.length> 0 ? false : true;
                    this.$nextTick(()=> {
                        let main = document.querySelector('.hrlistUl');
                        const h = window.innerHeight * 0.13;
                        main.style.marginBottom = h + 'px';
                    })
                }
            })
        },
        goTesting() {
            if(this.leariningMsg.questionNum === 0){
                return false;
            }
            if(this.leariningMsg.frequencyStatus === 3){
                this.$notify({
                    duration: 3000,
                    type: 'danger',
                    message: '测评已过期'
                });
            } else if(this.leariningMsg.frequencyStatus === 2){
                return false;
            } else if(this.leariningMsg.frequencyStatus === 4){
                this.$notify({
                    duration: 3000,
                    type: 'danger',
                    message: '还未到下一次测评时间'
                })
            } else {
                sessionStorage.setItem('countDownTime',new Date().getTime())
                sessionStorage.setItem('assessTime',this.leariningMsg.assessTime*60)
                this.$router.push({
                    path: '/humanResting/respondPage',
                    query: {
                        id: this.detailparams.id,
                        refId: this.detailparams.refId,
                        isValid: this.detailparams.isValid,
                        refType: this.detailparams.refType,
                        backType: this.$route.query.backType || '',
                        goodsId: this.$route.query.goodsId || '',
                    }
                })
            }
        },
        changecourseType(item) {
            this.changetype = item.id;
        },
        back() {
            if(this.$route.query.pathName){
                this.$router.push({ 
                    path: this.$route.query.pathName,  
                    query: {
                        goodsId: this.$route.query.goodsId,
                        goodsKind:this.$route.query.goodsKind,
                        distributionUserId:this.$route.query.distributionUserId,
                    }
                });
            }else{
                this.$router.push({ 
                    name: "learning",  
                    query: {
                        backType: this.$route.query.backType,
                    }
                });
            }
            
        },
        findByIdAndRef() {
            //简介
            let data = {
                assessId: this.detailparams.id || 11,
                isValid: this.detailparams.isValid || 0,
                refId: this.detailparams.refId || 11,
                refType: this.detailparams.refType || 1,
            };
            this.$api.testreport.findByIdAndRef({data}).then(data => {
                this.leariningMsg = data.data;
                //状态 0无限制 1可以评测 2剩余次数用完 3到期失效 4间隔天数未到
                this.cepingbtntext = this.leariningMsg.frequencyStatus === 2 ? '测评机会已用完' : this.leariningMsg.frequencyStatus===3?'测评已过期':'开始测评'
                this.isallow = [0,1].some(item => {
                    return item === this.leariningMsg.frequencyStatus;
                })
            });
        }
    }
};
</script> 
<style lang="less">
.hrDetails-Msgbox .van-tab__text {
    font-size: 18px;
}
.van-overlay /deep/ .wrapper {
    width: 100%;
    margin-top: 30px;
    position: relative;
}
body /deep/.van-toast{
    background:rgba(0,0,0,.7) !important;
}
</style>
<style lang="less" scoped>
@import '../asset/css/hrDetails.less';
</style>
